<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img
            class="w-7 h-7 rounded-full object-cover"
            *ngIf="showAvatar && user?.avatar"
            [src]="user?.avatar">
        <mat-icon
            *ngIf="!showAvatar || !user?.avatar"
            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    
    <!-- User info -->
    <div class="px-4 py-3 border-b">
        <p class="text-sm font-medium">{{ displayName }}</p>
        <p class="text-xs text-hint">{{ user?.email }}</p>
    </div>
    
    <!-- Current mode -->
    <div class="px-4 py-2 border-b">
        <p class="text-xs text-hint mb-1">{{ 'user.activeMode' | translate }}</p>
        <div class="flex items-center gap-2">
            <span class="w-2 h-2 rounded-full" 
                [ngClass]="isInTrainerMode ? 'bg-green-500' : 'bg-blue-500'"></span>
            <span class="text-sm font-medium">{{ isInTrainerMode ? ('auth.trainer' | translate) : ('auth.gym' | translate) }}</span>
        </div>
    </div>
    
    <!-- Mode switch -->
    <button
        *ngIf="modeButtonConfig.show"
        mat-menu-item
        (click)="onModeButtonClick()">
        <mat-icon [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
        <span>{{ modeButtonConfig.label }}</span>
    </button>
    
    <mat-divider *ngIf="modeButtonConfig.show"></mat-divider>
    
    <!-- Sign out -->
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>{{ 'auth.signOut' | translate }}</span>
    </button>
</mat-menu>
